export default {
  sentryKey: process.env.REACT_APP_SENTRY_KEY
};
